import { useSelector, useStore } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useRef } from 'react'

import LandingZoneTagsApi from '@api/landingZones/tags'

import * as landingZoneTagsMapping from '@store/landingZones/Tags/action'
import * as landingZoneTagsMappingType from '@store/landingZones/Tags/types'

import { useNavigate } from 'react-router-dom'
import { useAppSnackbar } from '@services/hooks/AppSnackbar'
import { useAppLoader } from '@services/hooks/AppLoader'
import { useApiError } from '@services/hooks/ApiError'

import { createId } from '@services/utils'
import { generateUrl } from '@services/routes'
import { ROUTE_LANDING_ZONES } from '@features/routes'

import { AZURE, useLandingZones } from '@features/hooks/LandingZones'

export const useLandingZoneTags = () => {
    const store = useStore()
    const dataStore = useSelector(state => state.landingZoneTags)
    const landingZoneTagsAction = bindActionCreators(landingZoneTagsMapping, store.dispatch)

    const { inLandingZones } = useLandingZones()
    const { hide: hideLoader, show: showLoader } = useAppLoader()
    const { handleError: apiError } = useApiError()
    const { show: showSnack } = useAppSnackbar()
    const navigate = useNavigate()

    const loaderCallback = useRef(null)

    const getData = (index = null) => {
        if (!index) return store.getState().landingZoneTags
        return store.getState().landingZoneTags[index]
    }

    const getAzure = (id) => {
        LandingZoneTagsApi.load(`/api/landing-zones/${id}/tags`, AZURE, 'lzManager', '/user_impersonation', {'x-api-version': '1.0'}, {
            success: (result) => {
                landingZoneTagsAction.populate(result?.data.data ?? [], () => {
                    landingZoneTagsAction.setLoaded(id, format)
                })
            },
            error: (result) => { apiError(result.data.message) }
        })
    }

    const format = () => {
        const raw = getData()
        const grid = []

        for (let i = 0; i < raw.data.items.length; i++) {
            const item = raw.data.items[i]
            grid.push({
                id: createId(),
                name: item.name ?? '-',
                value: item.value ?? '-',
                info: item.info ?? '-',
                hasError: item.hasError ?? false
            })
        }

        landingZoneTagsAction.setFormat({
            grid: grid,
            link: raw.data.url
        }, landingZoneTagsMappingType.SET_FORMAT, hideLoader)
    }

    const load = (id, callback = null) => {
        loaderCallback.current = callback

        if (dataStore.loaded === id) return

        landingZoneTagsAction.setFormat({grid: [], link: ''}, landingZoneTagsMappingType.SET_FORMAT, () => {
            if (!inLandingZones(id)) {
                hideLoader()
                showSnack(`Unknown landing zone`)
                return navigate(generateUrl(ROUTE_LANDING_ZONES))
            }

            showLoader(` `)

            getAzure(id)
        })
    }

    return { load }
}